module.exports = __webpack_public_path__ + "static/media/Calibration.dbfde10c.pdf";